import $ from "jquery";

function setTotalTableStyle(totalName, startIndex) {

    function adjustTable() {

        let element = null
        let totalWidth = 0;
        let scrollWidth = 18
        let totalId = "#" + totalName
        let tableHeaders = $(".table-header th.fixed-header")

        tableHeaders.each(function (index) {
            if (startIndex <= index) {
                element = $(this)
                if (index < tableHeaders.length - 1) {
                    let colWidth = element.innerWidth()

                    if(index === startIndex){
                        colWidth = colWidth / 2;
                    }
                    
                    let headId = totalId + "-" + index;
                    $(headId).css("maxWidth", colWidth)
                    $(headId).css("minWidth", colWidth)
                    $(headId).css("width", colWidth)
                    $(headId).css("text-align", "right")
                    $(headId).css("border", ".25px solid #ccc")
                    
                    totalWidth += colWidth
                }
            }
        });
       
        let margin = element && element.outerWidth()
        if (hasNoScroll()) {
            margin -= scrollWidth
        }

        $(totalId).css("float", "right")
        $(totalId).css("width", totalWidth)
        $(totalId).css("marginRight", margin)

    }

    $(window).resize(function () {
        adjustTable();
    });

    $(document).ready(function () {
        adjustTable();
    });

    adjustTable()

    function hasNoScroll() {
        let element = $(".tbody-fixed.table-responsive").get(0)
        return element && element.scrollHeight <= element.clientHeight;
    }

}


export {
    setTotalTableStyle
};